const getFormControllerRules = (
  label,
  required,
  validationOptions
) => ({
  required: required ? `${ label } is required` : undefined,
  // Spread the validationOptions object if provided
  ...validationOptions
});

export default getFormControllerRules;
